@let canGoBack = canShiftBack();
@let canGoForward = canShiftForward();

<button
  [type]="'button'"
  [id]="id() | appendTestId: 'year-picker'"
  [attr.data-testid]="id() | appendTestId: 'year-picker'"
  tabIndex="0"
  (keydown.space)="showYearPicker.set(!showYearPicker())"
  (click)="showYearPicker.set(!showYearPicker())"
  class="text-standard-text flex cursor-pointer flex-row bg-inherit">
  <div class="pointer-events-none">{{ shownYear() }}</div>
  <span class="material-symbols-rounded pointer-events-none"
    >arrow_drop_down</span
  >
</button>
@if (showYearPicker()) {
  <div
    [id]="id() | appendTestId: 'year-picker-popup'"
    [attr.data-testid]="id() | appendTestId: 'year-picker-popup'"
    class="border-input-ring rounded-input bg-input-background absolute top-0 bottom-0 left-0 z-10 box-border w-full border-1 py-5">
    <div
      [id]="id() | appendTestId: 'year-select'"
      class="relative flex h-full w-full flex-row items-center justify-center">
      <div
        class="absolute left-0 flex h-full items-center"
        [id]="id() | appendTestId: 'to-earlier-years'">
        <span
          [id]="id() | appendTestId: 'to-earlier-years-icon'"
          [attr.data-testid]="id() | appendTestId: 'to-earlier-years'"
          tabIndex="0"
          class="material-symbols-rounded !text-6xl"
          [ngClass]="{
            'cursor-pointer': canGoBack,
            'pointer-events-none cursor-not-allowed opacity-20': !canGoBack,
          }"
          (keydown.enter)="shiftYearsBack()"
          (click)="shiftYearsBack()"
          >chevron_left</span
        >
      </div>
      <div
        class="absolute right-0 flex h-full items-center"
        [id]="id() | appendTestId: 'to-future-years'">
        <span
          tabIndex="0"
          [id]="id() | appendTestId: 'to-future-years-icon'"
          [attr.data-testid]="id() | appendTestId: 'to-future-years'"
          class="material-symbols-rounded !text-6xl"
          [ngClass]="{
            'cursor-pointer': canGoForward,
            'pointer-events-none cursor-not-allowed opacity-20': !canGoForward,
          }"
          (keydown.enter)="shiftYearsForward()"
          (click)="shiftYearsForward()"
          >chevron_right</span
        >
      </div>
      <ul
        class="grid w-full grid-cols-3 gap-3 px-16"
        [id]="id() | appendTestId: 'years'"
        [attr.data-testid]="id() | appendTestId: 'years'">
        @for (year of years(); track year) {
          @let isYearBeforeMin = year | IsYearBeforeMin: min();
          @let isYearAfterMax = year | IsYearAfterMax: max();
          @let isNotInListDates =
            year | IsYearNotInDateList: restrictedDateList();
          <li
            tabindex="0"
            [id]="id() | appendTestId: 'year-label-' + $index"
            [attr.data-testid]="id() | appendTestId: 'year-' + $index"
            (keydown.enter)="selectYear(year)"
            (click)="onYearChange.emit(year); showYearPicker.set(false)"
            class="data-[active=false]:hover:bg-primary-main/20 cursor-pointer rounded-3xl px-2 py-1 text-center"
            [attr.data-active]="year === currentYear()"
            [ngClass]="{
              'bg-primary-main text-primary-on font-semibold':
                year === currentYear(),
              'pointer-events-none cursor-not-allowed opacity-20':
                isYearBeforeMin || isYearAfterMax || isNotInListDates,
            }">
            {{ year }}
          </li>
        }
      </ul>
    </div>
  </div>
}
